import { useState, useEffect } from 'react';
import { fetchJobsQueuesStatus, retryFailedJobs } from '../../../api/index.js';

const QueueStatus = () => {
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(false);
  const [retrying, setRetrying] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    fetchQueueStatus(); // Charger au départ
    const interval = setInterval(fetchQueueStatus, 5000); // Mettre à jour toutes les 5s
    return () => clearInterval(interval); // Nettoyer l'intervalle à la suppression du composant
  }, []);

  const fetchQueueStatus = async () => {
    setLoading(true);
    setError('');

    try {
      const response = await fetchJobsQueuesStatus();
      if (!response?.data) throw new Error('Impossible de récupérer les données');
      
      setStatus(response.data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleRetryFailedJobs = async () => {
    if (!window.confirm("Êtes-vous sûr de vouloir réessayer et supprimer les jobs en échec ?")) {
      return;
    }
  
    setRetrying(true);
    setError('');
  
    try {
      const response = await retryFailedJobs();
      fetchQueueStatus();
      alert(`✅ ${response.data.successful} réussis | 🔄 ${response.data.retried} réessayés | ❌ ${response.data.deleted} supprimés.`);
    } catch (err) {
      setError(err.message);
    } finally {
      setRetrying(false);
    }
  };

  return (
    <div>
      {/* <button onClick={fetchQueueStatus} disabled={loading}>
        {loading ? 'Chargement...' : 'Afficher l’état des queues'}
      </button> */}

      <button onClick={handleRetryFailedJobs} disabled={retrying || (status && status.failed === 0)}>
        {retrying ? 'Réessayage en cours...' : `Réessayer les jobs en échec (${status?.failed || 0})`}
      </button>

      {error && <p style={{ color: 'red' }}>{error}</p>}

      {status && (
        <div>
          <h3>Statut de la queue :</h3>
          <ul>
            <li>🕒 En attente : {status.waiting}</li>
            <li>⚙️ En cours : {status.active}</li>
            <li>❌ Échecs : {status.failed}</li>
            <li>⏳ Retardés : {status.delayed}</li>
            <li>✅ Complétés : {status.completed}</li>
          </ul>
        </div>
      )}
    </div>
  );
};

export default QueueStatus;
